// ** React Imports
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useMutation } from "react-apollo";
import { toast } from "react-toastify";
import SpinnerComponent from "../../../@core/components/spinner/Fallback-spinner";
import { FormatError } from "../../../@core/components/common/FormatError";
import moment from "moment";

//mutation
import { SIGN_IN } from "./mutation";

// ** Custom Components
import InputPasswordToggle from "@components/input-password-toggle";

// ** Reactstrap Imports
import {
  Card,
  CardBody,
  CardTitle,
  CardText,
  Form,
  Label,
  Input,
  Button,
  FormFeedback,
} from "reactstrap";

// ** Styles
import "@styles/react/pages/page-authentication.scss";
import "../../scss/authPages.scss";

const LoginBasic = () => {
  const refreshAtTimeItem = [
    "refreshAtDashboard",
    "refreshAtSalesData",
    "refreshAtCNFWise",
    "refreshAtBrandWise",
    "refreshAtProductStock",
    "refreshAtDCRegister",
    "refreshAtProvisionalStatement",
    "refreshAtEmployeeRights",
  ];

  const {
    control,
    // reset,
    // setError,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const history = useHistory();

  const [loginUser, { loading }] = useMutation(SIGN_IN, {
    fetchPolicy: "no-cache",
  });

  const [inputValue, setInputValue] = useState({
    userName: "",
    password: "",
  });
  const [geoLocation, setGeoLocation] = useState({
    latitude: "",
    longitude: "",
  });
  const [rememberMe, setRememberMe] = useState(false);

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  };
  const defaultUserName = getCookie("userName");

  useEffect(() => {
    getLocation();
  }, []);

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
      console.log(navigator.geolocation.getCurrentPosition(showPosition));
    } else {
      toast.warn("Geolocation is not supported by this browser.");
    }
  };
  const showPosition = (position) => {
    setGeoLocation({
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
    });
    return position;
  };

  const AddSubmitHandler = (data, e) => {
    getLocation();
    e.preventDefault();
    if (data?.userName && data?.password) {
      //  && geoLocation?.latitude && geoLocation?.longitude
      // if (data?.userName && data?.password && geoLocation?.latitude && geoLocation?.longitude) {
      if (rememberMe) {
        document.cookie = `userName=${data?.userName}`;
      }
      loginUser({
        variables: {
          userName: data?.userName,
          password: data?.password,
          lat: geoLocation?.latitude,
          long: geoLocation?.longitude,
        },
      })
        .then(async ({ data }) => {
          if (data?.loginUser?.token) {
            localStorage.setItem(
              "UserRes",
              JSON.stringify(data?.loginUser?.data)
            );
            if (
              data?.loginUser?.data?.EMAIL_ID_OFF &&
              window?.location?.hostname !== "localhost"
            ) {
              console.log("clarity called");
              window.clarity("identify", data?.loginUser?.data?.EMAIL_ID_OFF);
            }
            localStorage.setItem("token", data?.loginUser?.token);
            refreshAtTimeItem?.map((res) => {
              localStorage.setItem(res, JSON.stringify(moment().format("lll")));
              return res;
            });
            if (
              data?.loginUser?.data?.EMP_CODE &&
              ["H000001", "H000002", "H000003"].includes(
                data.loginUser.data.EMP_CODE
              )
            ) {
              history.push("/cnf-wise");
            } else {
              history.push("/dashboard");
            }
            toast.success("Logged in successfully");
          }
        })
        .catch((err) => {
          toast.warn(FormatError(err));
        });
    } else if (!data?.userName && !data?.password) {
      toast.error("Please enter username and password", {
        autoClose: 1000,
      });
    } else if (!geoLocation?.latitude && !geoLocation?.longitude) {
      toast.warn("Please allow to your location", { autoClose: 1000 });
    }
  };

  return (
    <>
      {loading ? (
        <SpinnerComponent />
      ) : (
        <div className="auth-wrapper auth-basic px-2 sign-in">
          <div className="auth-inner my-2">
            <Card className="mb-0">
              <CardBody className="sign-in-card">
                <Link
                  className="brand-logo"
                  to="/"
                  onClick={(e) => e.preventDefault()}
                >
                  <img
                    src={require(`@src/assets/images/logo/logo.svg`).default}
                    alt="logo"
                    height={"50"}
                    onClick={() => history.push("/")}
                  />
                </Link>
                <CardTitle tag="h4" className="sign-in-head">
                  Sales Sign-in 👨‍⚕️
                </CardTitle>
                <CardText className="sign-in-text">
                  This is a secure system and you will need to provide your
                  login details to access the site.
                </CardText>
                <Form
                  className="auth-login-form mt-2"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="mb-1">
                    <Label className="form-label" for="userName">
                      User name
                    </Label>
                    <Controller
                      id="userName"
                      name="userName"
                      defaultValue={defaultUserName}
                      {...register("userName", {
                        required: true,
                      })}
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <Input
                          type="text"
                          placeholder="Enter name"
                          onChange={(e) => {
                            onChange(e);
                            setInputValue({
                              ...inputValue,
                              userName: e.target.value,
                            });
                          }}
                          invalid={errors.userName && true}
                          autoFocus
                        />
                      )}
                    />
                    {errors && errors?.userName && (
                      <FormFeedback>
                        Please enter a valid user name
                      </FormFeedback>
                    )}
                  </div>
                  <div className="mb-1">
                    <Label className="form-label" for="password">
                      Password
                    </Label>
                    <Controller
                      id="password"
                      name="password"
                      defaultValue=""
                      {...register("password", {
                        required: true,
                      })}
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <InputPasswordToggle
                          className="input-group-merge"
                          onChange={(e) => {
                            onChange(e);
                            setInputValue({
                              ...inputValue,
                              password: e.target.value,
                            });
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              handleSubmit(AddSubmitHandler)(e);
                            }
                          }}
                          invalid={errors.password && true}
                        />
                      )}
                    />
                    {errors && errors?.password && (
                      <FormFeedback>Please enter a valid password</FormFeedback>
                    )}
                  </div>
                  <div className="form-check">
                    <Input
                      type="checkbox"
                      id="remember-me"
                      checked={rememberMe}
                      onChange={() => setRememberMe(!rememberMe)}
                    />
                    <Label className="form-check-label" for="remember-me">
                      Remember Me
                    </Label>
                  </div>
                  <Button
                    color={
                      inputValue?.userName !== "" && inputValue?.password !== ""
                        ? "primary"
                        : "secondary"
                    }
                    block
                    disabled={
                      inputValue?.userName !== "" && inputValue?.password !== ""
                        ? false
                        : true
                    }
                    onClick={handleSubmit(AddSubmitHandler)}
                  >
                    Sign-in
                  </Button>
                </Form>
                <div className="d-flex justify-content-center forgot-password-reset">
                  <p>Forgot Password?</p>
                  <Link to="/forgot-password" className="forgot-reset">
                    Reset
                  </Link>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      )}
    </>
  );
};

export default LoginBasic;
